export const FETCH_ELIGIBLE_STUDENTS_REQUEST = 'FETCH_ELIGIBLE_STUDENTS_REQUEST';
export const FETCH_ELIGIBLE_STUDENTS_SUCCESS = 'FETCH_ELIGIBLE_STUDENTS_SUCCESS';
export const FETCH_ELIGIBLE_STUDENTS_FAILURE = 'FETCH_ELIGIBLE_STUDENTS_FAILURE';
export const REQUEST_CERTIFICATES_REQUEST = 'REQUEST_CERTIFICATES_REQUEST';
export const REQUEST_CERTIFICATES_SUCCESS = 'REQUEST_CERTIFICATES_SUCCESS';
export const REQUEST_CERTIFICATES_FAILURE = 'REQUEST_CERTIFICATES_FAILURE';
export const FETCH_CERTIFICATE_REQUESTS_REQUEST = 'FETCH_CERTIFICATE_REQUESTS_REQUEST';
export const FETCH_CERTIFICATE_REQUESTS_SUCCESS = 'FETCH_CERTIFICATE_REQUESTS_SUCCESS';
export const FETCH_CERTIFICATE_REQUESTS_FAILURE = 'FETCH_CERTIFICATE_REQUESTS_FAILURE';
export const DOWNLOAD_CERTIFICATES_REQUEST = 'DOWNLOAD_CERTIFICATES_REQUEST';
export const DOWNLOAD_CERTIFICATES_SUCCESS = 'DOWNLOAD_CERTIFICATES_SUCCESS';
export const DOWNLOAD_CERTIFICATES_FAILURE = 'DOWNLOAD_CERTIFICATES_FAILURE';